import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fbe0c1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "resume-important__text mb-0"
}

import TariffNotificationModal from '@/components/TariffNotificationModal.vue';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeImportantModal',
  props: {
    hasActivePaidPeriod: { type: Boolean, default: false },
    hasPaymentData: { type: Boolean, default: true }
  },
  emits: ["resume", "cancel"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

// Если оплаченный период ещё идёт — списания сейчас не будет, поэтому
// текст про авто-оплату скрываем, а кнопку называем «Возобновить»
const showAutoPaymentText = computed(() => !props.hasActivePaidPeriod);
const paymentText = computed(() => (props.hasPaymentData
    ? 'Оплата произойдёт автоматически в ближайшее время.'
    : 'Вы перейдёте на страницу банка для оплаты. Карта сохранится для следующих списаний.'));
const buttonText = computed(() => (props.hasActivePaidPeriod ? 'Возобновить' : 'Оплатить'));

const emit = __emit;

function onResume() {
    emit('resume');
    hideModal();
}

function onCancel() {
    emit('cancel');
    hideModal();
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Важно",
    "button-text": buttonText.value,
    "secondary-button-text": "Оставить паузу",
    "max-width": 450,
    onButtonClick: onResume,
    onSecondaryButtonClick: onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", {
        class: _normalizeClass(["resume-important__text", { 'mb-0': !showAutoPaymentText.value }])
      }, " Если вы возобновите подписку сейчас, повторно взять паузу не получится. Заморозка PRO доступна только 1 раз в календарный год. ", 2),
      (showAutoPaymentText.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(paymentText.value), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["button-text"]))
}
}

})